import * as React from 'react';
import { Button } from '@helpcenter/analytics-components';
import { useIntl } from 'react-intl-next';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import messages from './messages';

interface BackButtonProps {
    text?: string;
    actionSubjectId: string;
    onClick: () => void;
}

const BackButton = (props: BackButtonProps) => {
    const { formatMessage } = useIntl();
    const { onClick, actionSubjectId, text } = props;
    const backButtonText = text ? text : formatMessage(messages.backButtonText);

    return (
        <Button
            appearance="subtle"
            actionSubjectId={actionSubjectId}
            onClick={onClick}
            aria-label={backButtonText}
            iconBefore={
                <ArrowLeftIcon label="" size="small" spacing="compact" color={token('color.icon', colors.N500)} />
            }
            data-test-id="back-button"
        >
            {backButtonText}
        </Button>
    );
};

export default BackButton;
